import React from "react";

function Icon({ className }: { className: string }) {
  return (
    <svg className={className} viewBox="0 0 23 23">
      <rect rx="2" width="23" height="23" fill="#d5d5d5" />
      <path
        d="M110.122,147.158a1.406,1.406,0,0,0-1.968-.07l-4.5,4.288-1.9-1.968a1.406,1.406,0,0,0-1.968-.07,1.476,1.476,0,0,0,0,2.038l2.882,2.952a1.265,1.265,0,0,0,.984.422,1.405,1.405,0,0,0,.984-.422l5.483-5.2a1.335,1.335,0,0,0,.081-1.887C110.178,147.211,110.151,147.184,110.122,147.158Z"
        transform="translate(-93.469 -139.234)"
        fill="#f8f8f8"
      />
    </svg>
  );
}

export { Icon };
